import { render } from "./UserPage.vue?vue&type=template&id=12e93677&scoped=true&ts=true"
import script from "./UserPage.vue?vue&type=script&lang=ts"
export * from "./UserPage.vue?vue&type=script&lang=ts"

import "./UserPage.vue?vue&type=style&index=0&id=12e93677&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e93677"]])

export default __exports__